// First-party operational diagnostics only. No analytics SDK, URL, identifiers,
// form values, queued pre-consent events or delivery retries. Only the visitor's
// optional diagnostics preference is stored, for the current browser tab.
const EVENTS = new Set(['editor_ready', 'editor_continue_attempt', 'editor_continue_saved', 'editor_continue_failed',
    'details_continue_attempt', 'details_validation_blocked', 'details_network_failed', 'details_autosave_failed', 'details_continue_failed',
    'signup_validation_blocked', 'signup_submit', 'auth_shown'])
const REASONS = new Set(['none', 'validation', 'invalid_time_range', 'network', 'save_failed'])
let budget = 30
const sent = new Set()
const preferenceKey = 'echoage:setup-diagnostics-consent'
let preference
try {
    const saved = window.sessionStorage.getItem(preferenceKey)
    if (saved === 'granted' || saved === 'denied') preference = saved
} catch (_) { /* a blocked preference store must not affect setup */ }

function privacySignalEnabled() {
    return navigator.globalPrivacyControl || navigator.doNotTrack === '1'
}

function consentGranted() {
    if (preference !== undefined) return preference === 'granted'
    const consent = window.echoageTrackingConsent
    const state = typeof consent === 'function' ? consent('analytics') : consent?.analytics
    return state === true || state === 'granted'
}

function syncPreferenceControls() {
    try {
        const blocked = privacySignalEnabled()
        document.querySelectorAll('[data-setup-diagnostics-preference]').forEach(container => {
            const input = container.querySelector('[data-setup-diagnostics-consent]')
            input.checked = !blocked && consentGranted()
            input.disabled = blocked
            container.hidden = blocked
        })
    } catch (_) { /* diagnostics must not affect setup */ }
}

document.addEventListener('change', event => {
    if (!document.querySelector('meta[name="setup-diagnostics-enabled"][content="1"]')) return
    if (!event.target.matches?.('[data-setup-diagnostics-consent]')) return
    preference = event.target.checked && !privacySignalEnabled() ? 'granted' : 'denied'
    try { window.sessionStorage.setItem(preferenceKey, preference) } catch (_) { /* tab memory still works */ }
    syncPreferenceControls()
    // No past events are queued or replayed when someone opts in.
})

export function reportSetupDiagnostic(event, reason = 'none') {
    try {
        if (!document.querySelector('meta[name="setup-diagnostics-enabled"][content="1"]')) return
        if (privacySignalEnabled() || !consentGranted()) return
        const key = `${event}:${reason}`
        if (!EVENTS.has(event) || !REASONS.has(reason) || budget <= 0 || sent.has(key)) return
        const csrf = document.querySelector('meta[name="csrf-token"]')?.content
        if (!csrf) return
        budget--
        sent.add(key)
        // Mark attempts locally to cap noise, not to claim platform receipt.
        // A telemetry outage must never hold up navigation or trigger replay.
        void fetch('/setup_diagnostics', {
            method: 'POST', credentials: 'same-origin', keepalive: true, referrerPolicy: 'no-referrer',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrf},
            body: JSON.stringify({event, reason})
        }).catch(() => {})
    } catch (_) { /* diagnostics never affect the user flow */ }
}

window.echoageSetupDiagnostics = {report: reportSetupDiagnostic}
document.addEventListener('turbo:load', () => {
    sent.clear()
    budget = 30
    syncPreferenceControls()
    const signupForms = document.querySelectorAll('[data-controller~="signup"], [data-controller~="inline-signup"]')
    if (Array.from(signupForms).some(form => form.getClientRects().length > 0)) {
        reportSetupDiagnostic('auth_shown')
    }
})
